export default [
  {
    path: '*',
    name: 'PageNotFound',
    component: () => import(/* webpackChunkName: "http" */ '@/views/http/PageNotFound.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: true,
      title: 'Página no encontrada'
    }
  },
  {
    path: '*',
    name: 'PermissionDenied',
    component: () => import(/* webpackChunkName: "http" */ '@/views/http/PermissionDenied.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: false,
      displayNavigation: false,
      displayOrganization: true,
      title: 'Permiso denegado'
    }
  }
]